import { Pipe, PipeTransform } from '@angular/core';

const statuses: Record<string, string> = {
  not_started: 'Not Started',
  under_review: 'Under Review',
  approved: 'Approved',
};

@Pipe({
  name: 'shIntakeDriverStatus',
})
export class ShIntakeDriverStatusPipe implements PipeTransform {
  public transform(value: string): unknown {
    return statuses[value];
  }
}
